var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProtect = function SvgProtect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.293.75a.75.75 0 0 1 .42 0l6.61 1.93a.75.75 0 0 1 .54.72v3.96c0 4.484-2.87 8.465-7.125 9.882a.75.75 0 0 1-.474 0 10.42 10.42 0 0 1-7.126-9.884V3.4a.75.75 0 0 1 .54-.72zM3.638 3.963v3.395A8.92 8.92 0 0 0 9.5 15.737a8.92 8.92 0 0 0 5.861-8.378V3.962L9.503 2.251zm10.066 2.119a.75.75 0 0 1 0 1.06l-4.408 4.409a.75.75 0 0 1-1.061 0L5.663 8.979a.75.75 0 1 1 1.061-1.06l2.041 2.04 3.878-3.877a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgProtect;